<template>
  <div class="materials-without-agreement">
    <div class="filters">
      <div class="filters__item">
        <CustomSelect
          :options="residents"
          label="ЖК"
          optionValueKey="resident_id"
          optionLabelKey="resident_name"
          :value="filters.resident_id"
          @change="onResidentChange"
        />
      </div>
      <div class="filters__item" style="width: 150px;">
        <CustomSelect
          :options="projectTypes"
          label="Тип проекта"
          optionValueKey="project_type_id"
          optionLabelKey="project_type_name"
          :value="filters.project_type_id"
          @change="onProjectTypeChange"
        />
      </div>
    </div>

    <CustomTable
      title="Материалы без договоров поставки"
      :rowsData="rowsData"
      :columns="columns"
      :loading="isLoading"
      :small="true"
      :show-search="true"
      :custom-body="true"
      :sticky-header="false"
      :update-data="this.loadMaterials"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.material_id }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.material_name || '-' }}
          </custom-table-cell>
          <custom-table-cell align="right" vertical-align="center">
            {{ numberWithCommas(props.row.material_price, '-') }}
          </custom-table-cell>
          <custom-table-cell align="right" vertical-align="center">
            {{ numberWithCommas(props.row.smeta_cnt, '-') }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.unit_name || '-' }}
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomSelect from "@/components/form/CustomSelect";
import { numberWithCommas } from "@/services";
import {
  getSmetaMaterialsWithoutAgreement,
  materialsWithoutAgreementColumns,
} from "@/views/ContractorAgreementList/services";
import { getProjectTypes, getResidentList } from "../ResidentialSettings/services";

export default {
  name: "MaterialsWithoutAgreement",
  components: { CustomTable, CustomTableCell, CustomSelect },
  data() {
    return {
      residents: [],
      projectTypes: [],
      rowsData: [],
      isLoading: false,
      columns: materialsWithoutAgreementColumns,
      filters: {
        resident_id: null,
        sbs_project_id: null,
        project_type_id: null,
      },
    };
  },
  methods: {
    numberWithCommas,
    async loadResidents() {
      const res = await getResidentList();
      this.residents = res || [];
    },
    async loadProjectTypes(resident_id) {
      const res = await getProjectTypes(resident_id);
      this.projectTypes = res || [];
    },
    async loadMaterials() {
      if (!this.filters.sbs_project_id) return;
      this.isLoading = true;
      const res = await getSmetaMaterialsWithoutAgreement({
        sbs_project_id: this.filters.sbs_project_id,
        project_type_id: this.filters.project_type_id,
      });
      this.isLoading = false;
      this.rowsData = res || [];
    },
    onResidentChange(value, row) {
      this.filters.resident_id = value;
      this.filters.sbs_project_id = row?.sbs_project_id || null;
      this.filters.project_type_id = null;
      this.projectTypes = [];
      this.rowsData = [];
      if (value) {
        this.loadMaterials();
        this.loadProjectTypes(value);
      }
    },
    onProjectTypeChange(value) {
      this.filters.project_type_id = value;
      this.rowsData = [];
      if (value) {
        this.loadMaterials();
      }
    },
  },
  mounted() {
    this.loadResidents();
  },
};
</script>

<style scoped lang="scss">
.materials-without-agreement {
  padding: 8px 0;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  margin-bottom: 16px;

  &__item {
    min-width: 150px;
    width: 240px;
  }
}
</style>
